import { h } from 'preact'
import UserAvatar from '../../User/UserAvatar'
import tracker from '../../../components/tracker/publish'
import { getCurrentPage } from '../../common/index'

export type FeaturedTopicData = {
  firstPost: {
    author: string,
    relativeCreationDate: string
  },
  url: string,
  title: string
}

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'notification',
    click_source: getCurrentPage()
  })
}

export const FeaturedSidebar = ({ data } : {data: Array<FeaturedTopicData>}) => {
  const topic = data[0]
  const author = topic.firstPost.author

  return (
    <a className='box sidebar-notification notification' onClick={eventTracker} href={topic.url}>
      <div className='box__content box__pad'>
        <p className='notification-title'>
          <div class='notification-link'>
            { topic.title }
          </div>
        </p>
        <span class='thread-meta-item'>
          <UserAvatar
            user={author}
            extraClass='avatar avatar--S'
            showRank
          />
          <div className='notification-link'>
            <span className='thread-meta-item__date'>
              { topic.firstPost.relativeCreationDate }
            </span>
          </div>
        </span>
      </div>
    </a>
  )
}

const FeaturedSidebarWithHelp = () => <div className='widget-configuration_info-box'>
    <strong>✨ How to highlight an announcement</strong>
    <p>Open a topic in control and add the moderator tag ‘featured_side’ to make it an announcement card.</p>
    <p>⚠️ This topic might be visible on other pages in your community, if announcement card widget is enable in General sidebar or Topic sidebar in Sidebar.</p>
    <p>⚠️ Only one topic can be featured</p>
</div>

export default FeaturedSidebarWithHelp
